import CompleteSignUpForm from "../components/CompleteSignUpForm";
import Container from "../components/Container";
import Image from "../components/Image";
import logo from "../assets/images/logo-transparent.png";
import logoFull from "../assets/images/logo-full.png";

export default function CompleteSignUpPage() {
    return (
        <Container between center fullHeight>
            <Container center fullWidth flexColumn>
                <Image src={logoFull} width={263} height={67} />
                <CompleteSignUpForm />
            </Container>

            <Container bgPrimary center fullWidth fullHeight hiddenMobile>
                <Image src={logo} width={325} height={325} />
            </Container>
        </Container>
    );
}
